import { ContainerOutlined } from "@ant-design/icons";
import { Badge, Button, Tooltip } from "antd";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HomeContext } from "../../containers/Home";
import { useMyTasksSummary } from "../../hooks/useDashboardQueries";
import { usePermissionStore } from "../../stores/permissionStore";

function MyTasksNavigationButton() {
	const navigate = useNavigate();
	const { currentTenantKey, userInfo }: any = useContext(HomeContext);
	const permissionsReady = usePermissionStore((state) => state.isInitialized);
	// The server refuses my-tasks to well-examiner sessions.
	const restricted = usePermissionStore(
		(state) => !!state.accessProfile?.restricted
	);
	// Same query as the dashboard's welcome card: every pending task assigned to the user.
	const { data } = useMyTasksSummary(
		permissionsReady && !restricted && currentTenantKey
			? { tenantKey: currentTenantKey, scope: "all" }
			: null,
		userInfo?.user?.email
	);
	// The header sits outside the page's error boundary, so never assume the shape.
	const pending = data?.totals?.pending ?? 0;
	// A partial count (source limit reached) is a lower bound.
	const pendingText = `${pending}${data?.truncated ? "+" : ""}`;

	return (
		<Tooltip title="Opens the My Tasks page to track your outstanding tasks.">
			<Badge count={pending} overflowCount={99} size="small">
				<Button
					shape="circle"
					icon={<ContainerOutlined />}
					aria-label={pending ? `My tasks, ${pendingText} pending` : "My tasks"}
					onClick={() => {
						navigate("/my-tasks");
					}}
				/>
			</Badge>
		</Tooltip>
	);
}

export default MyTasksNavigationButton;
